import React, { useEffect, useState } from 'react';
import AOS from 'aos';

export default function Intro({
  backgroundImage,
  mainTitle,
  productName,
  productModel,
  description,
  showWhiteFilter = false,
  theme = 'dark',
  center = false,
  nogredient = false,
}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const textColor = theme === 'light' ? 'fc-white' : 'fc-black1';

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out',
    });

    setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    AOS.refresh();
  }, []);

  return (
    <div className="sub_intro2">
      <div className={`sub_intro2_bg ${isLoaded ? 'zoom-in' : ''}`}>
        <img
          src={backgroundImage}
          alt={`${productName} ${productModel} 배경`}
        />

        {showWhiteFilter && <div className="white-filter"></div>}
      </div>
      <div className="center h-100">
        <div
          className={
            center
              ? 'col-flex flex-center txt-center sub_intro2_txts_center'
              : 'sub_intro2_txts txt-left'
          }
        >
          <p
            data-aos="fade-up"
            data-aos-delay="300"
            className={
              center
                ? `prt-bold fs-42 ${textColor} mb-2`
                : `prt-bold fs-42 ${textColor} mb-3`
            }
          >
            {mainTitle}
          </p>

          <h2
            data-aos="fade-up"
            data-aos-delay="500"
            className={
              center
                ? `prd_name prt-bold fs-80 ${textColor} mb-3`
                : `prd_name prt-bold fs-80 ${textColor} mb-5`
            }
          >
            {productName} <span className={nogredient ? "normal_text":"gradient-text"}>{productModel}</span>
          </h2>

          <p
            data-aos="fade-up"
            data-aos-delay="700"
            className={`description prt-regular fs-22 ${textColor} lh-16`}
          >
            {description}
          </p>
        </div>
      </div>
    </div>
  );
}
